module.exports = __webpack_public_path__ + "img/int.4474c3fd.jpg";